export default "__VITE_ASSET__OI6iwlml__"